// components/ReferrerTracker.tsx
import { useEffect } from "react";
import mixpanel from "mixpanel-browser";

export function ReferrerTracker() {
  useEffect(() => {
    mixpanel.init("ea3f3296a441dc670393b68e396f26d9", {
      debug: true,
      track_pageview: true,
      persistence: "localStorage",
    });

    const alreadyTracked = sessionStorage.getItem("referrer-tracked");
    if (alreadyTracked) return;

    const referrer = document.referrer;
    const currentHost = window.location.hostname;

    const isExternalReferrer =
      referrer && !referrer.includes(currentHost);

    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");
    const utmCampaign = params.get("utm_campaign");
    const utmTerm = params.get("utm_term");
    const utmContent = params.get("utm_content");

    const hasUtm = utmSource || utmMedium || utmCampaign;

    if (isExternalReferrer || hasUtm) {
      mixpanel.track("Visitor Attribution", {
        referrer: isExternalReferrer ? referrer : null,
        pathname: window.location.pathname,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_term: utmTerm,
        utm_content: utmContent,
      });

      sessionStorage.setItem("referrer-tracked", "true");
    }
  }, []);

  return null;
}
